<template>
    <v-container id="patrols-view-vertical" fluid tag="section" :class="{ 'pa-1': $vuetify.breakpoint.smAndDown }">
        <v-row class="flex-column" dense>
            <div v-for="(patrol) in patrols.results" :key="`patrol-${patrol.id}`" :class="cardMarginClass">
                <patrol-card-horizontal class="" :patrol="patrol"
                    v-on:click="showMore(patrol)"></patrol-card-horizontal>
            </div>
            <v-dialog v-model="dialog" fullscreen hide-overlay transition="dialog-bottom-transition">
                <material-patrol-card v-on:close="closeMore" :patrol="currentPatrol"></material-patrol-card>
            </v-dialog>
        </v-row>
    </v-container>
</template>

<script>
// Utilities
import { get, call } from 'vuex-pathify'

export default {
    name: 'PatrolsVertical',

    components: {
        PatrolCardHorizontal: () => import('./PatrolCardHorizontal'),
        MaterialPatrolCard: () => import('./MaterialPatrolCard')
    },

    data: () => ({
        dialog: false,
        currentPatrol: null,
        dialogModel: {},
    }),
    computed: {
        patrols: get('dashboard/patrols'),
        cardMarginClass() {
            // Smaller margins on small screens
            return this.$vuetify.breakpoint.smAndDown ? 'ma-0 mb-1' : 'ma-1'
        }
    },
    methods: {
        refreshX() {
            this.fetchPatrols()
            this.patrols.results.forEach(patrol => {
                if (patrol.id == this.currentPatrol.id) {
                    this.currentPatrol = patrol
                }
            })
            if (!this.dialog) {
                clearInterval(this.timer)
            }
        },
        closeMore() {
            this.dialog = false
            clearInterval(this.timer)
        },
        showMore(patrol) {
            this.currentPatrol = patrol
            this.timer = setInterval(this.refreshX, 2500)
            this.dialog = true
        },
        fetchPatrols: call("dashboard/fetchPatrols"),
        fetchPayments: call("payments/fetchPayments"),
    },
    beforeMount() {
        this.fetchPatrols()
        this.fetchPayments()
    },
}
</script>
